(function($){

	/**
	 * https://minhazav.medium.com/qr-code-scanner-using-html-and-javascript-3895a0c110cd
	 */

	let qrReader = document.querySelector('#qr-reader');

	if(!qrReader){
		return;
	}


	var html5QrcodeScanner = new Html5QrcodeScanner(
        'qr-reader', { fps: 10, qrbox: 250 });
    
    function onScanSuccess(decodedText, decodedResult) {

        console.log(decodedText);

        barer_is_ticket_ok(decodedText);

        // html5QrcodeScanner.clear();


        // if (decodedText !== lastResult) {
        //     ++countResults;
        //     lastResult = decodedText;

        //     console.log('Scan result = ${decodedText}', decodedResult); // decodedText será la url tipo: https://lanavemadrid.com/gate-control/?user_id=1&event_id=1478
        //     barer_is_ticket_ok(decodedText);
            
        //     // Optional: To close the QR code scannign after the result is found
        //     html5QrcodeScanner.clear();
        // }
    }
    
    // Optional callback for error, can be ignored.
    // function onScanError(qrCodeError) {
    // 	console.log(qrCodeError);
    // }
    
    html5QrcodeScanner.render(onScanSuccess);



    /**
     * Testing en local (No https)
     */

    let btn = $('#qr-test-button');

    btn.on('click',function(e){
    	e.preventDefault();
    	let decodedText = $('#qr-test').text();
        barer_is_ticket_ok(decodedText);

    });


    /**
     * Render alert
     */

    function barer_render_alert(alertClass,msg){
        let alertContainer = $('.lnm-gate-control__alerts .lnm-alert');

        alertContainer.removeClass('lnm-alert--error lnm-alert--success');
        alertContainer.html('');

        alertContainer.addClass(alertClass).html(msg);
    }


    /**
     * Recibe una url con parámetros y lanza petición ajax
     */
    function barer_is_ticket_ok(url){
        
        url = new URL(url);

        let user_id = url.searchParams.get("user_id");
        let event_id = url.searchParams.get("event_id");
        let host = url.host;

        // Si no tenemos datos o la url es incorrecta, ciao
        if( !user_id || !event_id || host != window.location.host){
            barer_render_alert('error','El código QR suministrado no es correcto. Faltan parámetros');
            return;
        }

        // $ajax
        $.ajax({
            type: "POST",
            dataType: "html",
            url: barer_var.url,
            data: {
                action : barer_var.action,
                nonce: barer_var.nonce,
                callback: 'barer-is-ticket-ok',
                barer_data: {
                    user_id: user_id,
                    event_id: event_id
                } 
            },
            success: function(data){

                if(data.length){

                    data = JSON.parse(data);
                    let lnmAlertClass = null;
                    let msg = '';

                    jQuery.each(data,function(key,value){
                        if(key == 'type'){
                            lnmAlertClass = "lnm-alert--" + value;
                        }else{
                            msg += '<p>' + value + '</p>';
                        }
                    });

                    barer_render_alert(lnmAlertClass,msg);

                } else{
                    barer_render_alert("lnm-alert--error",'Error de tipo desconocido');
                }

            },
            error : function(jqXHR, textStatus, errorThrown) {
                barer_render_alert("lnm-alert--error",'Error de tipo desconocido');
                console.log(errorThrown);
            }

        }); // $.ajax


    }


})(jQuery)